import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', to: '/' },
      { label: '职责与权限', to: '/category/zhize-quanxian' },
      { label: '任命流程', to: '/category/renming-liucheng' },
      { label: '管理技巧', to: '/category/guanli-jiqiao' },
    ],
  },
  {
    title: '更多内容',
    links: [
      { label: '社区运营', to: '/category/shequ-yunying' },
      { label: '晋升指南', to: '/category/jinsheng-zhinan' },
      { label: '案例分析', to: '/category/anli-fenxi' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '品牌介绍', to: '/about#brand' },
      { label: '联系方式', to: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer">
              第一版主
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              论坛版块管理核心指南，深度解析第一版主的职责、权限、任命流程与管理技巧，帮助论坛运营者与版主候选人打造高质量社区版块。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 第一版主. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}